import CheckboxSelected from '@assets/media/checkboxSelected.svg';
import FieldError from 'common/assets/bulsatcom/media/field_error.svg';
import { LoadingIndicator } from 'common/components/common/style';
import Icon from 'common/components/Icon';
import { APP_VERSION } from 'common/config/constants';
import variables from 'common/config/variables';
import { EpgsStore, LiveCategories, LiveChannels } from 'common/constants/data-types';
import { IPrismic } from 'common/reducers/prismic';
import { hasTokenInMemory } from 'common/services/helpers';
import { getClassName } from 'common/utils';
import { isEmpty, isNil } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import './DebugView.styles';
import { localTranslations } from './DebugView.utils';

interface DebugLineProps {
  label: string;
  success?: boolean;
  pending?: boolean;
}
function DebugLine(props: DebugLineProps) {
  return (
    <div className="debug-line">
      <span className="status">{props.label}</span>
      {!props.pending && (
        <span className={getClassName('status', { success: props.success, fail: !props.success })}>
          {props.success ? localTranslations.success : localTranslations.fail}
          <Icon src={props.success ? CheckboxSelected : FieldError} size="verySmall" />
        </span>
      )}
      {props.pending && (
        <span className={getClassName('status', { pending: props.pending })}>
          {localTranslations.pending}
          <LoadingIndicator />
        </span>
      )}
    </div>
  );
}

interface DebugViewProps {
  liveChannels?: LiveChannels;
  liveCategories?: LiveCategories;
  recorded?: EpgsStore['recorded'];
  vod?: EpgsStore['vod'];
  prismic?: IPrismic;
  userDetails?: any;
  hasErrors?: boolean;
  serverTime?: object;
  i18n?: object;
  playerIsLoading?: boolean;
}
function DebugView(props: DebugViewProps) {
  const hasLiveChannels = !isEmpty(props.liveChannels);
  const hasLiveCategories = !isEmpty(props.liveCategories);
  const hasRecorded = !isEmpty(props.recorded?.categories);
  const hasVod = !isNil(props.vod?.categories);
  const hasPrismic = !isEmpty(props.prismic);
  const hasUserDetails = !isEmpty(props.userDetails);
  const hasServerTime = !isEmpty(props.serverTime);
  const hasI18n = !isEmpty(props.i18n);
  const hasTokenObject = hasTokenInMemory();

  return (
    <div className="debug-view">
      <h4>{APP_VERSION}</h4>
      <h3>{localTranslations.title}</h3>
      <DebugLine
        label={localTranslations.checkingUserData}
        success={hasUserDetails}
        pending={!hasUserDetails}
      />
      <DebugLine
        label={localTranslations.checkingChannelsData}
        success={hasLiveChannels}
        pending={!hasLiveChannels}
      />
      <DebugLine label={localTranslations.checkingForErrors} success={!props.hasErrors} />
      <DebugLine
        label={localTranslations.checkingCategoriesData}
        success={hasLiveCategories}
        pending={!hasLiveCategories}
      />
      <DebugLine label={localTranslations.checkingVODData} success={hasVod} pending={!hasVod} />
      <DebugLine
        label={localTranslations.checkingRecordedData}
        success={hasRecorded}
        pending={!hasRecorded}
      />
      <DebugLine
        label={localTranslations.checkingPrismicData}
        success={hasPrismic}
        pending={!hasPrismic}
      />
      <DebugLine
        label={localTranslations.checkingServerTime}
        success={hasServerTime}
        pending={!hasServerTime}
      />
      <DebugLine
        label={localTranslations.checkingTranslationData}
        success={hasI18n}
        pending={!hasI18n}
      />
      <DebugLine label={localTranslations.checkingAuth} success={hasTokenObject} />
      {variables.LOADING_WAITS_FOR_PLAYER && (
        <DebugLine
          label={localTranslations.playerLoading}
          pending={props.playerIsLoading}
          success={!props.playerIsLoading}
        />
      )}
    </div>
  );
}

const mapStateToProps = ({
  i18n,
  liveChannels,
  liveCategories,
  epgs,
  prismic,
  userDetails,
  errors,
  serverTime,
  videoPlayer
}: any) => ({
  i18n,
  liveChannels,
  liveCategories,
  recorded: epgs.recorded,
  vod: epgs.vod,
  prismic,
  userDetails,
  hasErrors: Object.values(errors).every((e) => !!e),
  serverTime,
  playerIsLoading: !videoPlayer.isPlaying
});
export default React.memo(connect(mapStateToProps, {})(DebugView));
